import { Helmet } from 'react-helmet-async';
import { useContext } from 'react';
import { TranslationsContext } from '../../../context/TranslationsContext';

export const DigitalAvatarHelmet = () => {
  const { fullTranslations, mainLang } = useContext(TranslationsContext);

  return (
    <Helmet htmlAttributes={{ lang: mainLang, amp: undefined }}>
      <title>{fullTranslations?.head?.digitalAvatar?.title}</title>
      <meta
        name="description"
        content={fullTranslations?.head?.digitalAvatar?.description}
      />

      <meta
        property="og:url"
        content="https://www.mykin.in/services/digital-avatar"
      />
      <meta
        property="og:image"
        content="https://www.mykin.in/digitalAvatarPreview.png"
      />
      <meta property="og:image:width" content="800" />
      <meta property="og:image:height" content="600" />
      <meta
        property="og:title"
        content={fullTranslations?.head?.digitalAvatar?.title}
      />
      <meta
        property="og:description"
        content={fullTranslations?.head?.digitalAvatar?.ogDescription}
      />
      <meta
        name="twitter:image"
        content="https://www.mykin.in/digitalAvatarPreview.png"
      />
      <meta
        name="twitter:title"
        content={fullTranslations?.head?.digitalAvatar?.title}
      />
      <meta
        name="twitter:description"
        content={fullTranslations?.head?.digitalAvatar?.ogDescription}
      />
      <meta
        property="vk:url"
        content="https://www.mykin.in/services/digital-avatar"
      />

      <meta
        property="vk:image"
        content="https://www.mykin.in/digitalAvatarPreview.png"
      />
      <meta
        property="vk:title"
        content={fullTranslations?.head?.digitalAvatar?.title}
      />
      <meta
        property="vk:description"
        content={fullTranslations?.head?.digitalAvatar?.ogDescription}
      />
    </Helmet>
  );
};
